/**
 * Server rendering scripts.
 */
global.React = require('react');
global.ReactDOM = require('react-dom');
require('./css/core.scss');
require('./components');


// WEBPACK FOOTER //
// ./src/main.js